module.exports = __webpack_public_path__ + "24e004ab/img/search-filter-icon.c4751a52.svg";